import { PublicClientApplication } from "@azure/msal-browser";
import EventManagementEnum from "../../enum/EventManagementEnum";
import { IEventUserPrivilege } from "../../models/events/IEventRole";
import { IEventCreateChannel } from "../../models/events/IEventTeamChannel";
import EventManagementService from "../../services/events/eventmanagement.service";
import { APIHelper } from "../api/APIHelper";

export abstract class EventChannelHelper {
  public static async getEventChannels(
    msalInstance: PublicClientApplication,
    currentUserEmail: string,
    airportCode: string,
    eventId?: string
  ): Promise<any> {
    const eventManagementService = new EventManagementService();

    const getEventChannelsMethod = (accessToken: string) => {
      return eventManagementService.getEventChannels(
        accessToken,
        currentUserEmail,
        airportCode,
        eventId ? eventId : ""
      );
    };

    return APIHelper.CallAPI(msalInstance, null, getEventChannelsMethod);
  }

  public static async createChannel(
    msalInstance: PublicClientApplication,
    eventId: string,
    currentUserEmail: string,
    payload: IEventCreateChannel,
    airportCode: string
  ): Promise<any> {
    const eventManagementService = new EventManagementService();

    const createChannelMethod = (accessToken: string) => {
      return eventManagementService.createChannel(
        accessToken,
        eventId,
        currentUserEmail,
        payload,
        airportCode
      );
    };

    return APIHelper.CallAPI(msalInstance, payload, createChannelMethod);
  }

  public static async editChannel(
    msalInstance: PublicClientApplication,
    eventId: string,
    channelId: string,
    currentUserEmail: string,
    payload: IEventCreateChannel,
    airportCode: string
  ): Promise<any> {
    const eventManagementService = new EventManagementService();

    const editChannelMethod = (accessToken: string) => {
      return eventManagementService.editChannel(
        accessToken,
        eventId,
        channelId,
        currentUserEmail,
        payload,
        airportCode
      );
    };

    return APIHelper.CallAPI(msalInstance, payload, editChannelMethod);
  }

  public static async deleteChannel(
    msalInstance: PublicClientApplication,
    eventId: string,
    channelId: string,
    currentUserEmail: string,
    airportCode: string
  ): Promise<any> {
    const eventManagementService = new EventManagementService();

    const deleteChannelMethod = (accessToken: string) => {
      return eventManagementService.deleteChannel(
        accessToken,
        eventId,
        channelId,
        currentUserEmail,
        airportCode
      );
    };

    return APIHelper.CallAPI(msalInstance, null, deleteChannelMethod);
  }

  public static async getEventChannelInfo(
    msalInstance: PublicClientApplication,
    eventId: string,
    channelId: string,
    airportCode: string
  ): Promise<any> {
    const eventManagementService = new EventManagementService();

    const getEventChannelInfoMethod = (accessToken: string) => {
      return eventManagementService.getEventChannelInfo(
        accessToken,
        eventId,
        channelId,
        airportCode
      );
    };

    return APIHelper.CallAPI(msalInstance, null, getEventChannelInfoMethod);
  }

  public static async getChannelManagement(
    msalInstance: PublicClientApplication,
    eventId: string,
    currentUserEmail: string,
    airportCode: string
  ): Promise<any> {
    const eventManagementService = new EventManagementService();

    const getChannelManagementMethod = (accessToken: string) => {
      return eventManagementService.getChannelManagement(
        accessToken,
        eventId,
        currentUserEmail,
        airportCode
      );
    };

    return APIHelper.CallAPI(msalInstance, null, getChannelManagementMethod);
  }

  public static async updateChannelManagement(
    msalInstance: PublicClientApplication,
    eventId: string,
    currentUserEmail: string,
    payload: any,
    airportCode: string
  ): Promise<any> {
    const eventManagementService = new EventManagementService();

    const updateChannelManagementMethod = (accessToken: string) => {
      return eventManagementService.updateChannelManagement(
        accessToken,
        eventId,
        currentUserEmail,
        payload,
        airportCode
      );
    };

    return APIHelper.CallAPI(
      msalInstance,
      payload,
      updateChannelManagementMethod
    );
  }

  public static getChannelListData = (
    channels: any,
    isUserPartOfChannelMgmt: boolean
  ) => {
    const showEditDeleteOption = isUserPartOfChannelMgmt ?? false;
    return channels.map((channel: any) => ({
      id: channel.channelId,
      name: channel.name,
      responseTeam: `${channel.membersCount} members`,
      createdBy: channel.creator,
      isEdit: channel.isEdit && showEditDeleteOption,
      isDelete: channel.isDelete && showEditDeleteOption,
    }));
  };

  public static formatEventChannelResponse = (eventChannelsResponse: any) => {
    eventChannelsResponse.forEach((d: any) => {
      if (
        d.channelType.toLowerCase() ===
        EventManagementEnum.EventChannelType.Adhoc
      ) {
        d.isEdit = true;
        d.isDelete = true;
      } else {
        d.isEdit = false;
        d.isDelete = false;
      }
    });

    return eventChannelsResponse;
  };

  public static isUserPartOfChannelManagementTeam = (
    userPrivilege: IEventUserPrivilege
  ) => {
    return userPrivilege.isAOM || userPrivilege.partOfChannelManagementTeam;
  };
}
